module.exports = __webpack_public_path__ + "static/media/step-three-big.a8160e40.jpg";